import { isRead, isFavorite, buildFilter } from '../../../services/utils/leads';

export const setData = data => {
  return data.map(l => {
    l.isSelected = false;
    l.isRead = isRead(l.statuses);
    l.isFavorite = isFavorite(l.statuses);
    return l;
  });
};

export const selectedLead = (lead, leads) => {
  return leads.map(l => {
    if (lead.id === l.id) {
      return { ...l, isSelected: !l.isSelected };
    }
    return l;
  });
};

export const getQuerySringFilters = parameters => {
  let filters = '';
  if (parameters.offset !== undefined) {
    filters += `offset=${parameters.offset}`;
  }

  if (parameters.limit !== undefined) {
    filters += `&limit=${parameters.limit}`;
  }

  if (parameters.contactPublisherUserId) {
    filters += `&contactPublisherUserId=${parameters.contactPublisherUserId}`;
  }

  if (parameters.status) {
    if (parameters.status.indexOf('spam') !== -1) {
      filters += buildFilter('spam', 'true');
    } else {
      filters += buildFilter('spam', 'false');
    }
    filters += buildFilter('status', parameters.status);
  }

  if (parameters.actionType.length) {
    filters += buildFilter('action_type', parameters.actionType.map(f => f.value).toString());
  }

  if (parameters.textSearch) {
    filters += buildFilter('text', encodeURIComponent(parameters.textSearch));
  }

  if (parameters.feedback) {
    filters += '&feedback_not_responded=true';
  }

  if (parameters.sort) {
    filters += `&sort=${parameters.sort}`;
  }

  if (parameters.postingId) {
    filters += `&posting_id=${parameters.postingId}`;
  }

  return filters;
};

export const getSelectedLeads = leads => {
  return leads.filter(l => l.isSelected);
};

export const haveUnReadSelected = leads => {
  const unReadSelected = getSelectedLeads(leads).filter(s => !s.isRead);
  if (unReadSelected.length > 0) {
    return true;
  }
  return false;
};

export const allReadSelected = leads => {
  const readSelected = getSelectedLeads(leads).filter(s => s.isRead);
  if (readSelected.length === getSelectedLeads(leads).length) {
    return true;
  }
  return false;
};

export const allUnReadSelected = leads => {
  const unReadSelected = getSelectedLeads(leads).filter(s => !s.isRead);
  if (unReadSelected.length === getSelectedLeads(leads).length) {
    return true;
  }
  return false;
};

export const allSelectedWithStatusFavorite = leads => {
  const allfavorites = getSelectedLeads(leads).filter(s => s.isFavorite);
  if (allfavorites.length > 0) {
    if (allfavorites.length === getSelectedLeads(leads).length) {
      return true;
    }
  }
  return false;
};

export const allSelectedWithStatusNonFavorite = leads => {
  const allfavorites = getSelectedLeads(leads).filter(s => !s.isFavorite);
  if (allfavorites.length > 0) {
    if (allfavorites.length === getSelectedLeads(leads).length) {
      return true;
    }
  }
  return false;
};

export const isOneSelectedWithStatusNonFavorite = leads => {
  const allfavorites = getSelectedLeads(leads).filter(s => !s.isFavorite);
  if (allfavorites.length > 0) {
    return true;
  }
  return false;
};

export const selectedRowOption = leads => {
  const totalLeads = leads.length;
  const totalLeadsSelected = leads.filter(f => f.isSelected).length;
  if (totalLeads > 0) {
    if (totalLeads === totalLeadsSelected) {
      return 'all';
    }
    if (totalLeadsSelected > 0) {
      return 'single';
    }
  }
  return 'none';
};

export const updateSelectedOptions = (leads, status) => {
  return leads.map(l => {
    let isSelected = false;
    if (status === 'all') {
      isSelected = true;
    } else if (status === 'none' || status === 'single') {
      isSelected = false;
    }

    if (status === 'read') {
      isSelected = l.isRead === true;
    } else if (status === 'unread') {
      isSelected = l.isRead === false;
    }

    if (status === 'favorite') {
      isSelected = l.isFavorite === true;
    } else if (status === 'noFavorite') {
      isSelected = l.isFavorite === false;
    }
    return { ...l, isSelected };
  });
};

const getStatuses = status => {
  switch (status) {
    case 'READ':
      return 'UNREAD';
    case 'UNREAD':
      return 'READ';
    case 'FAVORITE':
      return 'NONFAVORITE';
    case 'NONFAVORITE':
      return 'FAVORITE';
    case 'DISCARDED':
      return 'NONDISCARDED';
    case 'NONDISCARDED':
      return 'DISCARDED';
    default:
      return '';
  }
};

export const updateLeads = (contactIds, leadStatus) => (leads, paging) => {
  if (leadStatus === 'DISCARDED' || leadStatus === 'SPAM') {
    const foundedIndex = leads.findIndex(lead => contactIds.includes(lead.contact_publisher_user_id));
    if (paging.total > 0) {
      paging.total -= 1;
    }
    leads.splice(foundedIndex, 1);
  }
  return leads.map(l => {
    const foundContact = contactIds.find(contactId => contactId === l.contact_publisher_user_id);
    if (foundContact) {
      l.statuses = l.statuses.filter(s => s !== getStatuses(leadStatus));
      l.statuses.push(leadStatus);
      l.isRead = isRead(l.statuses);
      l.isFavorite = isFavorite(l.statuses);
      if (!l.contact_response_status && l.contact_unreaded === true && leadStatus === 'READ') {
        l.contact_response_status = { id: '1' };
      }
    }
    return l;
  });
};

export const updateTabLastDate = (payload, tabs) => {
  return tabs.map(t => {
    if (payload && payload.key === t.key) {
      t.last = payload.fecha;
    }
    return t;
  });
};

export const updateTabLastNew = (payload, tabs) => {
  return tabs.map(t => {
    if (payload && payload[0].key === t.key) {
      t.new = payload[0].new;
    }

    return t;
  });
};

export const updateTabDisplay = (payload, tabs) => {
  return tabs.map(t => {
    if (payload && payload[0].key === t.key) {
      t.display = payload[0].display;
    }

    return t;
  });
};

export const updateTabLastFalse = (payload, tabs) => {
  return tabs.map(t => {
    if (payload && payload.key === t.key) {
      t.new = payload.new;
    }

    return t;
  });
};

export const updateTabSelected = tab => tabs => {
  return tabs.map(t => {
    t.isSelected = tab.key === t.key;
    return t;
  });
};

export const deselectAllTabs = tabs => {
  return tabs.map(tab => {
    if (tab.key === 'email') {
      tab.isSelected = true; // Marca la pestaña 'email' como seleccionada
    } else {
      tab.isSelected = false; // Deselecciona todas las otras pestañas
    }
    return tab;
  });
};
